import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ServiceProviderService } from './Service/Service-providers/service-provider.service';
import { LoaderService } from './Service/Loader/loader.service';
import { filter, Subscription } from 'rxjs';
import { WalletService } from './Service/wallet/wallet.service';
import { RechargePopupService } from './Service/wallet/recharge-popup.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  title = 'Autocare-web';
  role: number | null = null;
  showLayout: boolean = true;
  isLoading = false;
  showRechargePopup = false;

  constructor(
    private authService: ServiceProviderService,
    private router: Router,
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private walletService: WalletService,
    private popupService: RechargePopupService
  ) { }

  ngOnInit(): void {
    this.setupPopupSubscription();
    this.setupRouterEvents();
    this.checkWalletBalance();
  }

  ngAfterViewInit(): void {
    this.loaderService.isLoading$.subscribe(status => {
      this.isLoading = status;
      this.cdr.detectChanges();
    });
  }
  private setupPopupSubscription(): void {
    this.popupService.showPopup$.subscribe(show => {
      this.showRechargePopup = show;
      this.cdr.detectChanges();
    });
  }

  private setupRouterEvents(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');

      const isDistributor = user?.accessType === 4;
      const isApproved = user?.isApproved === true;
      const isPaymentDone = user?.isPaymentDone === true;

      if (isDistributor && isApproved && !isPaymentDone) {
        this.showLayout = true;
      } else {
        this.showLayout = true;
      }

      if (this.router.url === '/login') {
        this.role = null;
      } else {
        this.role = this.authService.getRole();
        // Check balance after successful navigation (including after login)
        this.checkWalletBalance();
      }
    });
  }

  checkWalletBalance() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = user?.accessType;

    // Only for SP, SA, Distributor   
    if ([1].includes(role)) {
      this.walletService.getWalletBalance().subscribe({
        next: (res) => {
          this.popupService.setShowPopup(res?.availableBalance <= 0);
        },
        error: () => {
          this.popupService.setShowPopup(false);
        }
      });
    } else {
      this.popupService.setShowPopup(false);
    }
  }
  loggedIn() {
    // Return false if on login page, or check if token exists
    if (this.router.url === '/login') {
      return false;
    }
    return this.authService.isLoggedIn();
  }


}

